const ChartBubble01Icon = /*#__PURE__*/ [
  ["path", { d: "M21 21H10C6.70017 21 5.05025 21 4.02513 19.9749C3 18.9497 3 17.2998 3 14V3", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "8", cy: "8", r: "2", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "11.5", cy: "15.5", r: "2.5", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["circle", { cx: "17.5", cy: "7.5", r: "3.5", stroke: "currentColor", strokeWidth: "1.5", key: "3" }]
];

export { ChartBubble01Icon as default };
//# sourceMappingURL=ChartBubble01Icon.js.map
